@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/xdr/sensors/base/styles/common.scss';

gz-title {
  margin-bottom: calc(var(--spacer) * 5);
}
